import React, { Component } from "react";
import IPSDataService from "../services/ips.service";
import countryList from 'react-select-country-list';
import Tooltip from '@mui/material/Tooltip';
import ReactTooltip from 'react-tooltip';

import { Modal, } from "react-bootstrap";

export default class PortfolioSummaryReport extends Component {

   
   
    constructor(props) {
      super(props);
     
      this.onChangeEmail = this.onChangeEmail.bind(this);
      this.onChangeFirstName = this.onChangeFirstName.bind(this);
      this.onChangeContact = this.onChangeContact.bind(this);
      this.onChangeLastName = this.onChangeLastName.bind(this);
      this.onChangePassword = this.onChangePassword.bind(this);
      this.onChangeRePassword = this.onChangeRePassword.bind(this);
      this.onChangePolicyCheck = this.onChangePolicyCheck.bind(this);
      this.options = countryList().getData();

      //  var date= moment().format("YYYY-MM-DD");
      this.state = {
        
        id: null,
        email:"",
        contact:"",
        fname:"",
        lname:"",
        password:"",
        repassword: "",
        submitted: false,
        captchacheck:false,
        operator:'',
        showModal: true,
        message:'',
        emailMessage:'',
    
      };
    }

     componentDidMount() 
    {  
        
    }
    
      closeModal()
      {
         this.setState({
         showModal: false,
         message:""
         });
         
      }

      
  
   openModal()
   {    
        if(this.state.submitted==false)
        {
         this.setState({
         showModal: true,
         message:""
         });
      }
   }

   

   onChangeEmail(e) 
   {
     this.setState({
       email: e.target.value
     });
   }

   onChangeFirstName(e)
    {
     this.setState({
       fname: e.target.value
     });
   }

   onChangeContact(e) 
   {
      this.setState({
         contact: e.target.value
      });
    }

   onChangeLastName(e) 
   {
     this.setState({
       lname: e.target.value
     });
   }

   onChangePolicyCheck(e) {

      this.setState({policycheck: !this.state.policycheck})
    }
 
   onChangePassword(e)
    {
     this.setState({
       password: e.target.value
     });
   }
 
   onChangeRePassword(e) 
   {
     this.setState({
       repassword: e.target.value
     });
   }


   actionModalSubmit()
   {
      this.saveAccount();
   }




   saveAccount()
    {
   
      document.getElementById("biosuccessMessage").innerHTML= '';
      document.getElementById("bioerrorMessage").innerHTML= '';
      

      var data = {
         email: this.state.email,
         fname: this.state.fname,
         contact: this.state.contact,
         lname: this.state.lname,
         
      };
     
      const reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
      if(this.state.email!=="")
      {
         if (reg.test(this.state.email) === false){
               
               document.getElementById("bioerrorMessage").innerHTML= "Invalid email address.";
               return false;
         }

      }
      IPSDataService.signupReport(data)
         .then(response => 
            {
               
               document.getElementById("biosuccessMessage").innerHTML= 'Details has been saved.';
               console.log(response.data);
               this.setState({
                  submitted: true,
                  showModal:false
                  });
             })

         .catch(e => 
            {
               document.getElementById("bioerrorMessage").innerHTML= e.response.data.message+"Please provide valid data";
               console.log(e);
             });
      }



    

 //////////////////////////////////

    render() {
       
        const {  } = this.state;
        
        const countryList = ["Afghanistan",	"Albania",	"Algeria",	"American Samoa",	"Andorra",	"Angola",	"Anguilla",	"Antarctica",	"Antigua and Barbuda",	"Argentina",	"Armenia",	"Aruba",	"Australia",	"Austria",	"Azerbaijan",	"Bahamas",	"Bahrain",	"Bangladesh",	"Barbados",	"Belarus",	"Belgium",	"Belize",	"Benin",	"Bermuda",	"Bhutan",	"Bolivia (Plurinational State of)",	"Bonaire, Sint Eustatius and Saba",	"Bosnia and Herzegovina",	"Botswana",	"Bouvet Island",	"Brazil",	"British Indian Ocean Territory",	"Brunei Darussalam",	"Bulgaria",	"Burkina Faso",	"Burundi",	"Cabo Verde",	"Cambodia",	"Cameroon",	"Canada",	"Cayman Islands",	"Central African Republic",	"Chad",	"Chile",	"China",	"Christmas Island",	"Cocos (Keeling) Islands",	"Colombia",	"Comoros",	"Congo (the Democratic Republic of the)",	"Congo",	"Cook Islands",	"Costa Rica",	"Croatia",	"Cuba",	"Curaçao",	"Cyprus",	"Czechia",	"Côte d'Ivoire",	"Denmark",	"Djibouti",	"Dominica",	"Dominican Republic",	"Ecuador",	"Egypt",	"El Salvador",	"Equatorial Guinea",	"Eritrea",	"Estonia",	"Eswatini",	"Ethiopia",	"Falkland Islands [Malvinas]",	"Faroe Islands",	"Fiji",	"Finland",	"France",	"French Guiana",	"French Polynesia",	"French Southern Territories",	"Gabon",	"Gambia",	"Georgia",	"Germany",	"Ghana",	"Gibraltar",	"Greece",	"Greenland",	"Grenada",	"Guadeloupe",	"Guam",	"Guatemala",	"Guernsey",	"Guinea",	"Guinea-Bissau",	"Guyana",	"Haiti",	"Heard Island and McDonald Islands",	"Holy See",	"Honduras",	"Hong Kong",	"Hungary",	"Iceland",	"India",	"Indonesia",	"Iran (Islamic Republic of)",	"Iraq",	"Ireland",	"Isle of Man",	"Israel",	"Italy",	"Jamaica",	"Japan",	"Jersey",	"Jordan",	"Kazakhstan",	"Kenya",	"Kiribati",	"Korea (the Democratic People's Republic of)",	"Korea (the Republic of)",	"Kuwait",	"Kyrgyzstan",	"Lao People's Democratic Republic",	"Latvia",	"Lebanon",	"Lesotho",	"Liberia",	"Libya",	"Liechtenstein",	"Lithuania",	"Luxembourg",	"Macao",	"Madagascar",	"Malawi",	"Malaysia",	"Maldives",	"Mali",	"Malta",	"Marshall Islands",	"Martinique",	"Mauritania",	"Mauritius",	"Mayotte",	"Mexico",	"Micronesia (Federated States of)",	"Moldova (the Republic of)",	"Monaco",	"Mongolia",	"Montenegro",	"Montserrat",	"Morocco",	"Mozambique",	"Myanmar",	"Namibia",	"Nauru",	"Nepal",	"Netherlands",	"New Caledonia",	"New Zealand",	"Nicaragua",	"Niger",	"Nigeria",	"Niue",	"Norfolk Island",	"Northern Mariana Islands",	"Norway",	"Oman",	"Pakistan",	"Palau",	"Palestine, State of",	"Panama",	"Papua New Guinea",	"Paraguay",	"Peru",	"Philippines",	"Pitcairn",	"Poland",	"Portugal",	"Puerto Rico",	"Qatar",	"Republic of North Macedonia",	"Romania",	"Russian Federation",	"Rwanda",	"Réunion",	"Saint Barthélemy",	"Saint Helena, Ascension and Tristan da Cunha",	"Saint Kitts and Nevis",	"Saint Lucia",	"Saint Martin (French part)",	"Saint Pierre and Miquelon",	"Saint Vincent and the Grenadines",	"Samoa",	"San Marino",	"Sao Tome and Principe",	"Saudi Arabia",	"Senegal",	"Serbia",	"Seychelles",	"Sierra Leone",	"Singapore",	"Sint Maarten (Dutch part)",	"Slovakia",	"Slovenia",	"Solomon Islands",	"Somalia",	"South Africa",	"South Georgia and the South Sandwich Islands",	"South Sudan",	"Spain",	"Sri Lanka",	"Sudan",	"Suriname",	"Svalbard and Jan Mayen",	"Sweden",	"Switzerland",	"Syrian Arab Republic",	"Taiwan",	"Tajikistan",	"Tanzania, United Republic of",	"Thailand",	"Timor-Leste",	"Togo",	"Tokelau",	"Tonga",	"Trinidad and Tobago",	"Tunisia",	"Turkey",	"Turkmenistan",	"Turks and Caicos Islands",	"Tuvalu",	"Uganda",	"Ukraine",	"United Arab Emirates",	"United Kingdom of Great Britain and Northern Ireland",	"United States Minor Outlying Islands",	"United States of America",	"Uruguay",	"Uzbekistan",	"Vanuatu",	"Venezuela (Bolivarian Republic of)",	"Viet Nam",	"Virgin Islands (British)",	"Virgin Islands (U.S.)",	"Wallis and Futuna",	"Western Sahara",	"Yemen",	"Zambia",	"Zimbabwe",	"Åland Islands"];
        
        

        return (
   
      <div>
         <div className="col-md-12 col-xs-12" style={{padding:'0px'}}>

         <iframe title="Demo - Portfolio Summary" width="100%" height="800" src="https://app.powerbi.com/view?r=eyJrIjoiNjZkNDRiZmEtZDI1MC00NTlhLWE2Y2MtMzJlMWViN2Y0Y2YxIiwidCI6IjZjYjQyMTIyLTQ5N2QtNDA2ZS04Yjk0LThmNWVkOTM2NTUxNCIsImMiOjh9&pageName=ReportSectionc1f260a7d749407eb415" frameborder="0" allowFullScreen="true"></iframe> 

         </div>
      


    <div className="row">

            <Modal id="biodata-modal" size="md" dialogClassName="modal-90w" show={this.state.showModal} backdrop="static" onHide={this.closeModal.bind(this)}>
               <Modal.Header>
                  <Modal.Title style={{width:'95%'}}>
                     <div className="modal-heading">How can we contact you?</div>
                  </Modal.Title>
                  {/*<a style={{width:'5%'}} onClick={this.closeModal.bind(this)}><i className="fa fa-times"></i></a> */}
               </Modal.Header>
               <Modal.Body >
                  <div>
                     <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                           <div className="modal-body">
                              <div className="row">
                                 <div className="col-md-6 ">
                                    <div className="form-group">
                                       <label>First Name*</label>
                                       <input type="text" className="form-control" value={this.state.fname}  onChange={this.onChangeFirstName} id="firstName" placeholder="Enter your first name" />
                                    </div>
                                 </div>
                                 <div className="col-md-6">
                                    <div className="form-group">
                                       <label>Last Name</label>
                                       <input type="text" className="form-control" value={this.state.lname}  onChange={this.onChangeLastName} id="lastName" placeholder="Enter your last name" />
                                    </div>
                                 </div>
                              </div>
                          
                              <div className="row">
                                 <div className="col-md-6 ">
                                    <div className="form-group"     style={{display: 'none'}}>
                                       <label>Contact Number*</label>
                                       <input type="tel" className="form-control" id="inputEmail" value={this.state.contact}   onChange={this.onChangeContact} placeholder="Enter your contact number" />
                                    </div>
                                 </div>
                                 <div className="col-md-12 ">
                                    <div className="form-group">
                                       <label>Email Address*</label>
                                       <input type="email" onChange={this.onChangeEmail} value={this.state.email} className="form-control" id="inputEmail" placeholder="Enter your email address" />
                                    </div>
                                 </div>
                              </div>
                              {!this.state.submitted ? (
                              <div>
                                 <div className="row">
                                    <div className="col-md-1">
                                    </div>
                                    <div className="col-md-10">
                                       <div className="form-group">
                                          <button type="submit" onClick={this.actionModalSubmit.bind(this)} className="btn modal-next-btn" id="submit-button">Submit</button>
                                       </div>
                                    </div>
                                    <div className="col-md-1">
                                    </div>
                                 </div>
                               
                              </div>
                              ) :  (     
                              <div className="row">
                                 <div className="col-md-1">
                                 </div>
                                 <div className="col-md-10">
                                    <div className="form-group">
                                       <button type="submit" onClick={this.closeModal.bind(this)} className="btn modal-next-btn" id="submit-button">Close</button>
                                    </div>
                                 </div>
                                 <div className="col-md-1">
                                 </div>
                              </div>
                              )}
                              <p id="bioerrorMessage" style={{color:"red",width: '100% !important',textAlign:'center'}}></p>
                              <p  id="biosuccessMessage" style={{color:"green",width: '100% !important',textAlign:'center'}}></p>
                           </div>
                        </div>
                     </div>
                  </div>
               </Modal.Body>
            </Modal>




            



            

       
        <div className="col-md-12">
       
        
         

        </div> 
    </div>

</div>


  
   );
}
}